// extracted by mini-css-extract-plugin
export default {"creditbtn":"wallet_creditbtn__AePQ3","walletgrid":"wallet_walletgrid__oLqyJ"};